import './PageInvoices.scss';
import HeaderLine from "../../components/headerLine/HeaderLine";
import InvoicesGrid from '../../components/grids/invoices/InvoicesGrid';

export default function PageReports(props) {
  return (
    <div className="page-reports">
      <HeaderLine selectedPage='invoices' />
      <InvoicesGrid />
    </div>
  );
}
